<!-- <template>
    <div class="video" ref="playerRef" style="width: 800px;height: 400px;z-index: 99;border: 1px solid white;"></div>
</template>
<script>
    import { QNRTPlayer } from "qn-rtplayer-web";
    export default {
      data() {
        return {
          playerRtc: null
        }
      },
      mounted() {
        let that = this
        setTimeout(() => {
          that.videoPlay()
        },1000)
      },
      methods: {
        videoPlay() {
          const that = this
          that.playerRtc = new QNRTPlayer();
          that.playerRtc.init({
            controls: false
          });
          that.playerRtc.play("webrtc://qvs-live.thirdMonitor.concoai.com:1240/2xenzwqy2ppcl/31011500991180009748_34020000001310000001",that.$refs.playerRef);
        }
      },
      beforeDestroy() {
        this.playerRtc.release()
        this.playerRtc = null
      }
    }
</script>
<style scoped>
</style> -->

<template>
    <div>
      <el-date-picker v-model="date" type="datetimerange" range-separator="至" start-placeholder="开始日期"
		end-placeholder="结束日期"     value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions">
      </el-date-picker>
    </div>
</template>
<script>
    import {
      bd09togcj02,
      gcj02tobd09,
      wgs84togcj02,
      gcj02towgs84
    } from '../../components/CWGS84.js'
    export default {
        data() {
			let  _minTime = null
			let  _maxTime = null
            return {
              dialogClose: require('../../../static/img/close.png'),
			  date:[],
			  pickerOptions: {
			    onPick(time) {
			      if (!time.maxDate&&time.minDate) {
			        let timeRange = 1 * 41 * 60 * 60 * 1000
			        _minTime = time.minDate.getTime() - timeRange
			        _maxTime = time.minDate.getTime() + timeRange
			      } else if(!time.maxDate&&!time.minDate){
			        _minTime = _maxTime = null
			      }
			    },
			    disabledDate(time) {
			      if (_minTime && _maxTime) {
			        return time.getTime() < _minTime || time.getTime() > _maxTime
			      } else {
			        return time.getTime() < (Date.now() -1 * 41 * 60 * 60 * 1000 )
			      }
			    }
			  }
            }
        },
        mounted() {
          // console.log(wgs84togcj02(121.519357167,38.8539853333)[1],wgs84togcj02(121.519357167,38.8539853333)[0])
        },
        methods: {
        }
    }
</script>
<style scoped>
  #container{
    width:1200px;
    height: 800px;
  }
</style>
<!-- <template>
     <div style="width: 400px;height: 400px;background-color: pink;position: relative;margin: 100px;zoom: 1;cursor: pointer;">
        <div style="position: absolute;width: 100%;height: 100%;z-index: 999;opacity: 0;" @click.stop="drawPoint($event)"></div>
        <div v-for="(objd, index) in drawList" :key="'point' + index" class="pointClass" :style="{left: objd.x + 'px', top: objd.y + 'px'}"></div>
        <div v-for="(objl, index) in lineList" :key="'lines' + index" class="linesClass" :style="{left: objl.left + 'px', top: objl.top + 'px', width: objl.width + 'px','transform-origin': `0 0`,'-webkit-transform': `rotate(${objl.rotate}deg)`}"></div>
     </div>
 </template>
 <script>
    export default {
        data() {
            return {
                drawList: [],
                lineList: []
            }
        },
        mounted() {
            this.drawList = [{
              x: 110,
              y: 200
            }, {
              x: 220,
              y: 110
            }, {
              x: 185,
              y: 250
            },{
              x: 355,
              y: 290
            }]
            this.drawLine()
        },
        methods: {
          drawLine(ev) {
              let that = this
              let dr_Len = that.drawList.length
              if (dr_Len > 1) {
                for(var i = 0;i < that.drawList.length;i++) {
                  if (i < that.drawList.length-1) {
                    let cWidth = that.calculationWidth({
                        x1: that.drawList[i].x,
                        y1: that.drawList[i].y,
                        x2: that.drawList[i+1].x,
                        y2: that.drawList[i+1].y
                    })
                    let cRotate = that.calculationRotate({
                        x1: that.drawList[i].x,
                        y1: that.drawList[i].y,
                        x2: that.drawList[i+1].x,
                        y2: that.drawList[i+1].y
                    })
                    that.lineList.push({
                        width: cWidth,
                        rotate: cRotate-180,
                        top: that.drawList[i].y+1.5,
                        left: that.drawList[i].x+1.5,
                    })
                  }
                }
              }
          },
            drawPoint(ev) {
                let that = this
                that.drawList.push({
                    x: (ev.offsetX)/1,
                    y: (ev.offsetY)/1
                })
                let dr_Len = that.drawList.length
                if (dr_Len > 1) {
                    let cWidth = that.calculationWidth({
                        x1: that.drawList[dr_Len-2].x,
                        y1: that.drawList[dr_Len-2].y,
                        x2: that.drawList[dr_Len-1].x,
                        y2: that.drawList[dr_Len-1].y
                    })
                    let cRotate = that.calculationRotate({
                        x1: that.drawList[dr_Len-2].x,
                        y1: that.drawList[dr_Len-2].y,
                        x2: that.drawList[dr_Len-1].x,
                        y2: that.drawList[dr_Len-1].y
                    })
                    that.lineList.push({
                        width: cWidth,
                        rotate: cRotate-180,
                        top: that.drawList[dr_Len-2].y+1.5,
                        left: that.drawList[dr_Len-2].x+1.5,
                    })
                }
            },
            // 计算长度
            calculationWidth(xy) {
                return Math.sqrt((xy.x2 - xy.x1) * (xy.x2 - xy.x1) + (xy.y2 - xy.y1) * (xy.y2 - xy.y1));
            },
            // 计算角度
            calculationRotate(xy) {
                let radian = Math.atan2(xy.y1 - xy.y2, xy.x1 - xy.x2);
                let angle = 180 / Math.PI * radian;
                return angle;
            }
        }
    }
 </script>
 <style scoped>
    .pointClass {
        width: 3px;
        height: 3px;
        background-color: black;
        border-radius: 50%;
        position: absolute;
    }
    .linesClass {
        position: absolute;
        height: 1px;
        border-top: 2px solid red;
    }
 </style>



// WEBPACK FOOTER //
// src/page/video/video.vue